import { supabaseClient } from "supabase";

export type UpdateApplicationParams = {
  id: number;
  processed: boolean;
};

export const updateApplication = async ({
  id,
  processed,
}: UpdateApplicationParams) => {
  const { error } = await supabaseClient
    .from("applications")
    .update({ processed })
    .eq("id", id);

  if (error) {
    throw error;
  }

  return { id, processed };
};
